<template>
  <div class="app-container">
    <header class="navbar">
      <div class="nav-left">
        <i class="el-icon-arrow-left back-icon" @click="backHome()"></i>
        <h2 class="page-title">面试登记表配置</h2>
        <el-tag effect="plain" size="mini" class="status-tag">编辑中</el-tag>
      </div>
      <div class="nav-right">
        <div class="switch-group">
          <span class="label-text">启用登记表</span>
          <el-switch v-model="post.formEnabled" active-color="#13ce66" @change="openTable"></el-switch>
        </div>
        <el-divider direction="vertical"></el-divider>
        <el-button :disabled="!post.formEnabled" size="medium" round type="primary" @click="save()">发布更新</el-button>
      </div>
    </header>
    <div class="main-layout">
      <div class="config-content" ref="scrollContainer">
        <section v-for="(group, gIndex) in formGroups" :key="gIndex" :ref="'section_' + gIndex" class="config-card">
          <div class="card-header">
            <div class="title-wrapper">
              <span class="title-bar"></span>
              <h3>{{ group.groupName }}</h3>
            </div>
            <div class="action-wrapper" v-if="group.groupName === '家庭情况'">
              <!-- <el-divider direction="vertical"></el-divider> -->
              <span class="sub-text">启用模块</span>
              <el-switch v-model="group.enabled" size="small"></el-switch>
            </div>
          </div>

          <div class="card-body">
            <el-input type="textarea" :rows="6" placeholder="请在这里填写该模块的填写须知..." v-model="group.desc"
              v-if="group.descShow" class="custom-textarea"></el-input>
            <div class="table-container" v-if="group.descShow === false">
              <table class="pretty-table">
                <thead>
                  <tr>
                    <th width="60">序号</th>
                    <th>字段显示名称</th>
                    <th width="100">设为必填</th>
                    <th width="100">状态</th>
                    <th width="80">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(field, fIndex) in group.fields" :key="fIndex" :class="{ disabled: !field.enabled }">
                    <td>{{ fIndex + 1 }}</td>

                    <td>
                      <span class="field-name">{{ field.name }}</span>
                    </td>

                    <td>
                      <el-checkbox v-model="field.required" :disabled="!field.enabled"></el-checkbox>
                    </td>

                    <td>
                      <el-switch v-model="field.enabled" size="small" :disabled="field.isDisabled"></el-switch>
                    </td>

                    <td>
                      <el-button type="text" class="del-text" v-if="field.canDelete"
                        @click="handleDelete(gIndex, fIndex)">
                        删除
                      </el-button>
                      <span v-else class="lock-icon" title="系统核心字段，不可删除">
                        <i class="el-icon-lock"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
      <aside class="side-nav">
        <div class="nav-sticky-card">
          <div class="nav-header">表单大纲</div>
          <div class="nav-items">
            <div v-for="(nav, nIndex) in formGroups" :key="nIndex" class="nav-item"
              :class="{ active: activeNav === nIndex }" @click="scrollToSection(nIndex)">
              <i :class="activeNav === nIndex ? 'el-icon-location' : 'el-icon-place'"></i>
              {{ nav.groupName }}
            </div>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import { getRegConfig, setRegConfig, saveRegConfig } from '@/request/api'
export default {
  data() {
    return {
      activeNav: 0,
      formGroups: [
        {
          groupName: '基础信息',
          enabled: true,
          descShow: false,
          desc: '',
          fields: [
            { name: '渠道来源', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '应聘岗位', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '姓名', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '性别', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '手机号', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '邮箱', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '民族', enabled: true, required: true, canDelete: false },
            { name: '籍贯', enabled: true, required: true, canDelete: false },
            { name: '户口', enabled: false, required: false, canDelete: false },
            { name: '政治面貌', enabled: true, required: true, canDelete: false },
            { name: '出生年月', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '身份证号码', enabled: false, required: false, canDelete: false },
            { name: '健康状况', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '婚姻状况', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '子女情况', enabled: false, required: false, canDelete: false },
            { name: '最高学历', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '工作年限', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '身高cm', enabled: false, required: false, canDelete: false },
            { name: '体重kg', enabled: false, required: false, canDelete: false },
            { name: '在职状况', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '到岗时间', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '目前薪资', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '期望薪资', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '现居住址', enabled: true, required: true, canDelete: false, isDisabled: true },
          ]
        },
        {
          groupName: '家庭情况',
          enabled: true,
          descShow: false,
          desc: '',
          fields: [
            { name: '姓名', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '与本人关系', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '工作单位', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '职位', enabled: true, required: true, canDelete: false, isDisabled: true },
            { name: '联系电话', enabled: true, required: true, canDelete: false, isDisabled: true },
          ]
        },
        {
          groupName: '教育背景',
          enabled: true,
          descShow: false,
          desc: '',
          fields: [
            { name: '起止时间', enabled: true, required: true, editable: true, canDelete: false, isDisabled: true },
            { name: '毕业院校', enabled: true, required: true, editable: true, canDelete: false, isDisabled: true },
            { name: '所学专业', enabled: true, required: true, editable: true, canDelete: false, isDisabled: true },
            { name: '学历', enabled: true, required: true, editable: true, canDelete: false, isDisabled: true },
            { name: '是否统招', enabled: true, required: true, editable: true, canDelete: false, isDisabled: true },
            { name: '所获证书', enabled: true, required: true, editable: true, canDelete: false, isDisabled: true },
          ]
        },
        {
          groupName: '工作经历',
          enabled: true,
          descShow: false,
          desc: '',
          fields: [
            { name: '起止时间', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
            { name: '公司名称', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
            { name: '职位', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
            { name: '离职原因', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
            { name: '收入', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
            { name: '工作证明人', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
            { name: '证明人联系方式', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
          ]
        },
        {
          groupName: '其他信息',
          enabled: true,
          descShow: false,
          desc: '',
          fields: [
            { name: '自我评价', enabled: true, required: false, editable: true, canDelete: false, isDisabled: true },
          ]
        },
        {
          groupName: '诚信声明',
          enabled: true,
          descShow: true,
          desc: '1、本人承诺以上所填信息全部属实，如录用之后发现填报资料虚假或失实，公司有权解除劳动合同，且不用支付任何补偿；\n2、本人同意公司通过第三方对本人工作经历进行背景调查；',
        }
      ],
      post: {
        formEnabled: null,// 启用登记表
      }
    };
  },
  computed: {
    enabledFormGroups() {
      return this.formGroups.filter(group => group.enabled);
    }
  },
  created() {
    this.getRegConfig();
  },
  mounted() {
    window.addEventListener('resize', this.checkIfMobile);
    window.addEventListener('scroll', this.handleScroll);
    // 初始化滚动监听
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfMobile);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async save() {
      // 转换布尔值为数字
      const convertBooleansToNumbers = (obj) => {
        const converted = JSON.parse(JSON.stringify(obj));
        const traverse = (item) => {
          if (Array.isArray(item)) {
            item.forEach(traverse);
          } else if (typeof item === 'object' && item !== null) {
            Object.keys(item).forEach(key => {
              if (typeof item[key] === 'boolean') {
                item[key] = item[key] ? 1 : 0;
              } else {
                traverse(item[key]);
              }
            });
          }
        };
        traverse(converted);
        return converted;
      };

      const convertedGroups = convertBooleansToNumbers(this.formGroups);
      const { data: res } = await saveRegConfig({
        username: JSON.parse(sessionStorage.getItem("LoginInfo")).username,
        groups: convertedGroups
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
      } else {
        this.$message.error('保存失败');
      }
    },
    async openTable() {
      const { data: res } = await setRegConfig({ username: JSON.parse(sessionStorage.getItem("LoginInfo")).username });
      if (res.data === 1) {
        this.$message.success('开启在线登记表');
        this.post.formEnabled = true;
      } else {
        this.$message.error('关闭在线登记表');
        this.post.formEnabled = false;
      }
    },
    async getRegConfig() {
      const { data: res } = await getRegConfig({
        username: JSON.parse(sessionStorage.getItem("LoginInfo")).username
      });

      if (res.code === 200) {
        const serverData = res.data;
        this.post.formEnabled = serverData.switch === 1;

        // 1. 扩展映射表，增加是否需要锁定的配置
        const fieldConfigs = {
          // 基础信息：核心字段通常需要锁定状态
          "channel": { label: "渠道来源", locked: true },
          "interviewJob": { label: "应聘岗位", locked: true },
          "name": { label: "姓名", locked: true },
          "gender": { label: "性别", locked: true },
          "phone": { label: "手机号", locked: true },
          "email": { label: "邮箱", locked: true },
          "birthDate": { label: "出生年月", locked: true },
          "health": { label: "健康状况", locked: true },
          "marital": { label: "婚姻状况", locked: true },
          "higDegree": { label: "最高学历", locked: true },
          "employment": { label: "在职状况", locked: true },
          "joinDate": { label: "到岗时间", locked: true },
          "currSalary": { label: "目前薪资", locked: true },
          "expSalary": { label: "期望薪资", locked: true },
          "currResidence": { label: "现居住址", locked: true },
          // 其他字段：可选开启或锁定
          "housType": { label: "住址性质", locked: true },
          "nation": { label: "民族", locked: false },
          "origin": { label: "籍贯", locked: false },
          "politics": { label: "政治面貌", locked: false },
          "IDcard": { label: "身份证号码", locked: false },
          "household": { label: "户口", locked: false },
          "children": { label: "子女情况", locked: false },
          "bodyHeight": { label: "身高cm", locked: false },
          "bodyWeight": { label: "体重kg", locked: false },
          "jobExp": { label: "工作年限", locked: true },
          // 家庭/教育/工作经历（这些通常都是系统写死的逻辑，建议全部锁定状态）
          "homeName": { label: "姓名", locked: true },
          "homeRelationship": { label: "与本人关系", locked: true },
          "homeWorkName": { label: "工作单位", locked: true },
          "homeJobName": { label: "职位", locked: true },
          "homePhone": { label: "联系电话", locked: true },
          "eduDate": { label: "起止时间", locked: true },
          "eduName": { label: "毕业院校", locked: true },
          "eduMajor": { label: "所学专业", locked: true },
          "eduDegree": { label: "学历", locked: true },
          "eduNature": { label: "是否统招", locked: true },
          "eduCertificate": { label: "所获证书", locked: true },
          "workDate": { label: "起止时间", locked: true },
          "workName": { label: "公司名称", locked: true },
          "workJobName": { label: "职位", locked: true },
          "workReason": { label: "离职原因", locked: true },
          "workIncome": { label: "收入", locked: true },
          "workWitness": { label: "工作证明人", locked: true },
          "workPhone": { label: "证明人联系方式", locked: true },
          "myself": { label: "自我评价", locked: true }
        };

        // 2. 增强版的转换函数
        const mapFields = (list) => {
          if (!list) return [];
          return list
            .filter(item =>
              item.name !== 'IntegrityStatement' &&
              !item.name.endsWith('Config') &&
              item.name !== 'workExp'
            )
            .map(item => {
              const config = fieldConfigs[item.name] || { label: item.name, locked: false };
              return {
                name: config.label,
                enabled: item.show,
                required: item.required,
                canDelete: false,
                // 关键点：这里重新赋值 isDisabled
                isDisabled: config.locked
              };
            });
        };

        // 3. 重新填充 formGroups
        this.formGroups = [
          {
            groupName: '基础信息',
            descShow: false,
            fields: mapFields(serverData.baseInfo)
          },
          {
            groupName: '家庭情况',
            enabled: serverData.homeConfig === 1 ? true : false,
            descShow: false,
            fields: mapFields(serverData.homeInfo)
          },
          {
            groupName: '教育背景',
            descShow: false,
            fields: mapFields(serverData.education)
          },
          {
            groupName: '工作经历',
            descShow: false,
            fields: mapFields(serverData.workInfo)
          },
          {
            groupName: '其他信息',
            descShow: false,
            fields: mapFields(serverData.baseInfo.filter(i => i.name === 'myself'))
          },
          {
            groupName: '诚信声明',
            descShow: true,
            desc: serverData.baseInfo.find(i => i.name === 'IntegrityStatement')?.desc.replace(/<br\/>/g, '\n') || ''
          }
        ];
      }
    },
    scrollToSection(index) {
      this.activeNav = index;
      const element = this.$refs['section_' + index][0];
      if (element) {
        // 计算偏移，防止被顶部导航挡住
        const top = element.offsetTop - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    },
    handleScroll() {
      // 获取当前滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      // 获取所有配置卡片的元素
      let currentSectionIndex = 0;

      for (let i = 0; i < this.formGroups.length; i++) {
        const sectionRef = this.$refs['section_' + i];
        if (sectionRef && sectionRef.length > 0) {
          const section = sectionRef[0];
          const offsetTop = section.offsetTop;
          const height = section.offsetHeight;

          // 判断当前滚动位置是否在该section范围内
          if (scrollTop >= offsetTop - 200 && scrollTop < offsetTop + height - 200) {
            currentSectionIndex = i;
            break;
          } else if (scrollTop >= offsetTop - 200) {
            currentSectionIndex = i;
          }
        }
      }

      this.activeNav = currentSectionIndex;
    },
    backHome() {
      this.$router.push('/home/search');
    },
    // 删除字段方法
    handleDelete(groupIndex, fieldIndex) {
      const fieldName = this.formGroups[groupIndex].fields[fieldIndex].name;

      this.$confirm(`确定要删除“${fieldName}”字段吗？此操作不可撤销。`, '安全提醒', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
        roundButton: true, // 让按钮圆角化，更符合美化后的风格
        customClass: 'custom-confirm-box' // 方便后续自定义弹窗样式
      }).then(() => {
        // 执行删除
        this.formGroups[groupIndex].fields.splice(fieldIndex, 1);

        this.$message({
          type: 'success',
          message: '删除成功',
          duration: 2000
        });
      }).catch(() => {
        // 点击取消不执行任何操作
      });
    },
  }
};
</script>

<style lang="scss" scoped>
// 定义主题变量，方便统一修改
$primary-color: #1890ff;
$success-color: #13ce66;
$danger-color: #ff4d4f;
$bg-body: #f0f2f5;
$bg-card: #ffffff;
$text-main: #1f1f1f;
$text-secondary: #595959;
$border-color: #f0f0f0;
$radius-lg: 12px;
$radius-sm: 8px;
$shadow-light: 0 2px 8px rgba(0, 0, 0, 0.04);
$shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.08);

.app-container {
  background-color: $bg-body;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  box-sizing: border-box;

  // 1. 顶部导航栏
  .navbar {
    height: 64px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .nav-left {
      display: flex;
      align-items: center;

      .back-icon {
        font-size: 20px;
        cursor: pointer;
        margin-right: 16px;
        color: #606266;

        &:hover {
          color: $primary-color;
        }
      }

      .page-title {
        font-size: 18px;
        font-weight: 600;
        color: #1f2f3d;
        margin: 0 12px 0 0;
      }

      .status-tag {
        border-radius: 4px;
        border: none;
        background: #e8f4ff;
        color: $primary-color;
      }
    }

    .nav-right {
      display: flex;
      align-items: center;

      .switch-group {
        display: flex;
        align-items: center;

        .label-text {
          font-size: 14px;
          color: $text-secondary;
          margin-right: 8px;
        }
      }

      .el-divider {
        display: none; // 在移动端隐藏垂直分割线

        @media (min-width: 769px) {
          display: block;
          margin: 0 20px;
        }
      }

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 10px;

        .switch-group {
          margin-bottom: 10px;
        }
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
      height: auto;
      padding: 16px;
      gap: 16px;

      .nav-left {
        justify-content: center;

        .page-title {
          margin: 0 10px;
        }
      }

      .nav-right {
        width: 100%;
        justify-content: center;
      }
    }
  }

  // 2. 主体布局
  .main-layout {
    display: flex;
    max-width: 1200px;
    margin: 24px auto;
    gap: 24px;
    padding: 0 20px;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 0 10px;
      gap: 16px;
    }

    .config-content {
      flex: 1;

      // 配置卡片
      .config-card {
        background: $bg-card;
        border-radius: $radius-lg;
        box-shadow: $shadow-light;
        margin-bottom: 24px;
        overflow: hidden;
        transition: all 0.3s ease;
        border: 1px solid $border-color;

        &:hover {
          box-shadow: $shadow-hover;
        }

        .card-header {
          padding: 20px 24px;
          border-bottom: 1px solid $border-color;
          display: flex;
          justify-content: space-between;
          align-items: center;

          @media (max-width: 768px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }

          .title-wrapper {
            display: flex;
            align-items: center;

            .title-bar {
              width: 4px;
              height: 18px;
              background: $primary-color;
              border-radius: 2px;
              margin-right: 12px;
            }

            h3 {
              margin: 0;
              font-size: 16px;
              color: $text-main;
            }
          }

          .action-wrapper {
            display: flex;
            align-items: center;

            .sub-text {
              font-size: 13px;
              color: #8c8c8c;
              margin-right: 8px;
            }
          }
        }

        .card-body {
          padding: 24px;

          @media (max-width: 768px) {
            padding: 16px;
          }

          // 穿透修改 Element UI 输入框
          ::v-deep .el-textarea__inner {
            background-color: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: $radius-sm;
            padding: 12px;
            margin-bottom: 20px;

            &:focus {
              background-color: #fff;
              border-color: $primary-color;
            }
          }
        }
      }
    }

    // 3. 右侧导航大纲
    .side-nav {
      width: 220px;

      .nav-sticky-card {
        position: sticky;
        top: 88px;
        background: $bg-card;
        border-radius: $radius-lg;
        padding: 16px 0;
        box-shadow: $shadow-light;

        .nav-header {
          padding: 0 20px 12px;
          font-weight: 600;
          color: $text-main;
          border-bottom: 1px solid $border-color;
          margin-bottom: 8px;
        }

        .nav-items {
          .nav-item {
            padding: 12px 20px;
            font-size: 14px;
            color: $text-secondary;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 8px;

            &:hover {
              color: $primary-color;
              background: #f0f7ff;
            }

            &.active {
              color: $primary-color;
              background: #e6f7ff;
              font-weight: 600;
              border-right: 3px solid $primary-color;
            }
          }
        }
      }
    }
  }
}

// 4. 表格样式优化
.table-container {
  margin: 0 auto;
  max-width: 1000px; // 限制表格最大宽度，避免过度拉伸
  border: 1px solid $border-color;
  border-radius: $radius-sm;
  overflow: hidden;

  .pretty-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; // 建议加上，可以让各列宽度更匀称

    th,
    td {
      padding: 14px 10px;
      text-align: center; // 水平居中
      vertical-align: middle; // 垂直居中
      font-size: 14px;
      word-break: break-all; // 防止长文本撑开表格

      @media (max-width: 768px) {
        padding: 10px 6px;
        font-size: 13px;
      }
    }

    th {
      background: #fafafa;
      color: $text-secondary;
      font-weight: 600;
      border-bottom: 1px solid $border-color;
    }

    td {
      border-bottom: 1px solid $border-color;
      color: $text-main;
      transition: background 0.2s;

      .field-name {
        font-weight: 500;
      }

      .del-text {
        color: $danger-color;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      .lock-icon {
        color: #bfbfbf;
      }
    }

    tr {
      &:hover td {
        background: #fbfcfe;
      }

      // 当状态为关闭时，整行置灰
      &.disabled {
        td {
          color: #bfbfbf;
          background-color: #fafafa;
        }

        .field-name {
          color: #bfbfbf;
        }
      }
    }
  }
}
</style>